import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KonPermission } from 'app/modules/UIKit/components/kontable/utility/utility-model';
import { ClassificationType } from '../../models/classification.model';
import { DataTableService } from '../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../modules/UIKit/components/dataTable/dataTableField.interface';
import { ClassificationService } from '../../services/classification/classification.service';

@Component({
  selector: 'app-classification-types',
  templateUrl: './classification-types.component.html'
})

export class ClassificationTypesComponent {

  titles: DataTableField[];
  customButtons: DataTableCustomButton[];
  public perm: KonPermission = new KonPermission();
  @Output() onBackClick: EventEmitter<any> = new EventEmitter();

  constructor (public svc: ClassificationService,
               private translate: TranslateService,
               private srvDataTable: DataTableService) {
    this.svc.getTypes().subscribe();

    this.translate.get([
      'common.classification_types_name',
      'common.back'
    ]).subscribe((res) => {
      console.log(res);
      this.titles = [
        { id: 'id', label: '#' },
        { id: 'name', label: res['common.classification_types_name'], editable: true },
      ];

      this.customButtons = [
        {
          callbackname: 'back',
          isAlwaysEnabled: true,
          label: res['common.back'],
          icon: 'fa fa-angle-double-left'
        }
      ]

    });
    this.perm.edit = false;
    this.perm.view = false;
  }

  onEditInline(event) {
    this.svc.putType(event).subscribe();
    this.svc.editingType = null;
  }

  onDeleteInline(event) {
    this.svc.deleteType(event).subscribe();
  }

  onAdd(event) {
    this.svc.postType(event).subscribe();
    this.svc.editingType = null;
    this.srvDataTable.get('dt_classification_types').showDetail = false;

  }

  showAddDialog(data) {
    this.svc.editingType = new ClassificationType();
  }

  onCustomButton(event) {
    switch (event.callbackName) {
      case 'back':
        this.onBackClick.emit();
        break;
    }
  }

  onDialogHide () {
    this.svc.editingType = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/classification-types/classification-types.component.ts